// @flow

import styled from 'styled-components';

export const Separator = styled.hr`
  border: none;
  border-bottom: 1px solid ${props => props.theme.colors.gray(96)};
`;
